<div class="credit-rule-item-dialog">
  <mat-dialog-content>
    <h3 class="header">Test {{type === 'credit-rule-item' ? 'Credit Rule Item' : type === 'credit-rule' ? 'Credit Rule' : type === 'credit-flow-node' ? 'Credit Flow Node' : 'Credit Flow'}}</h3>
    <div class="row filters-row">
      <div class="col-md-12 col-lg-9">
        <mat-form-field class="select">
          <mat-label>Search Application</mat-label>
          <input type="text" matInput [formControl]="formControlApplication" [matAutocomplete]="auto"
            placeholder="Search by Application ID or Name">
          <span class="mdi mdi-magnify" matPrefix></span>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="applicationDisplayWithFn" (optionSelected)="selectApplication($event.option.value)">
            @for (app of filteredApplications; track $index) {
            <mat-option [value]="app">
              {{ app.BrokerAppId }} - {{ app.CompanyName }} ({{app.ApplicationType}}) - {{app.StageName}}
            </mat-option>}
            @if (filteredApplications.length === 0) {
            <mat-option disabled>
              No results found
            </mat-option>}
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-md-12 col-lg-3" fxLayout="row" fxLayoutAlign="end start">
        <button color="primary" mat-flat-button (click)="onEvaluate()">Evaluate</button>
      </div>
    </div>

    @if (results && results.length) {
      <div class="row mb-4">
        <div class="col-12">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px" class="width-100">
                    <div>Results</div>
                    <tag-box [state]="resultStatus"></tag-box>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <credit-flow-details [flowData]="results" [creditFlowResult]="[]"></credit-flow-details>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
      
      <div class="row mb-4">
        <div class="col-12">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Application Data
                </mat-panel-title>
              </mat-expansion-panel-header>
              <ngx-json-viewer [json]="sampleApplicationData ?? {}" [expanded]="false"></ngx-json-viewer>
              <div class="width-100" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
                <button mat-flat-button color="primary" [cdkCopyToClipboard]="sampleApplicationString" (click)="onCopy()">Copy to Clipboard</button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    }

    <div class="row">
      <div class="col-12">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <button color="primary" (click)="onCancel()" mat-stroked-button>Close</button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>